/**
 * h5-proxy web 调试模式的环境配置。
 *
 * 由 process.env.REACT_APP_* 读取,生产构建(bridge 模式)不会触发 proxy 逻辑,
 * 因此这些配置仅在 dev 下使用。
 *
 * 变量说明见项目根目录 .env.development 与 .env.development.local.example。
 */
const env = process.env;

const config = {
  // 请求分发开关: 'proxy' | 'bridge'(缺省走 jsBridge)
  mode: env.REACT_APP_API_MODE,
  baseUrl: env.REACT_APP_PROXY_BASE_URL,
  applicationCode: env.REACT_APP_PROXY_APPLICATION_CODE,
  // 数字型字段做显式转换,与 h5-proxy 的 config.js 保持一致
  deviceType: env.REACT_APP_PROXY_DEVICE_TYPE ? Number(env.REACT_APP_PROXY_DEVICE_TYPE) : undefined,
  channel: env.REACT_APP_PROXY_CHANNEL ? Number(env.REACT_APP_PROXY_CHANNEL) : undefined,
  uuid: env.REACT_APP_PROXY_UUID,
  signKey: env.REACT_APP_PROXY_SIGN_KEY,
  passwordPrefix: env.REACT_APP_PROXY_PASSWORD_PREFIX,
  lang: env.REACT_APP_PROXY_LANG,
  email: env.REACT_APP_PROXY_EMAIL,
  password: env.REACT_APP_PROXY_PASSWORD,
};

if (config.mode === 'proxy') {
  const requiredFields = [
    ['baseUrl', 'REACT_APP_PROXY_BASE_URL'],
    ['applicationCode', 'REACT_APP_PROXY_APPLICATION_CODE'],
    ['deviceType', 'REACT_APP_PROXY_DEVICE_TYPE'],
    ['channel', 'REACT_APP_PROXY_CHANNEL'],
    ['uuid', 'REACT_APP_PROXY_UUID'],
    ['signKey', 'REACT_APP_PROXY_SIGN_KEY'],
    ['lang', 'REACT_APP_PROXY_LANG'],
    ['email', 'REACT_APP_PROXY_EMAIL'],
    ['password', 'REACT_APP_PROXY_PASSWORD'],
  ];
  const missing = requiredFields
    .filter(([field]) => config[field] === undefined || config[field] === null || config[field] === '')
    .map(([, envName]) => envName);
  if (missing.length > 0) {
    // eslint-disable-next-line no-console
    console.warn(`[h5-proxy] 缺少必要的环境变量: ${missing.join(', ')}`);
  }
}

export default config;
